import React from "react";

import {
  Input,
} from "../../../components/Input.components";
import { Boxed } from "../../../components/Boxed.components";
import { Button } from '../../../components/Button.components';
import { ModalComponent } from "../../../components/Modal.components";

import { calcViewMode } from "../../../utils/utils";
import { PageTitle } from "../../../components/style";

export const ConfirmationModal = (props) => {
  // State props
  const {
    openConfirmationModal,
    isLoading,
    applicationData,
  } = props;

  // Dispatch props
  const {
    form,
    closeModal,
    decisionApplication,
  } = props;
  const { getFieldProps, getFieldError, validateFields, } = form;

  let viewMode = calcViewMode();

  const onSubmit = () => {
    validateFields((error, values) => {
      if (!error) {
        const data = {
            observation: values?.observation?.trim()
        };
        decisionApplication({ data, id: applicationData?._id, type: openConfirmationModal});
      }
    });
  };

  return (
    <>
      <ModalComponent
        show={openConfirmationModal}
        onHide={closeModal}
        title={<PageTitle margin="5px 0">Confirm Action</PageTitle>}
        footer={
          <Boxed display="flex" width="100%">
            <Button clear onClick={closeModal}>
              Cancel
            </Button>
            <Button
              margin="0 0 0 auto"
              progress={isLoading}
              disabled={isLoading}
              onClick={onSubmit}
            >
              {openConfirmationModal}
            </Button>
          </Boxed>
        }
      >
         <Boxed pad="10px 0">
            <Input
              type="text"
              label="Comment"
              // width={"85%"}
              placeholder="Enter Comment..."
              error={getFieldError("observation") ? "Comment is required" : null}
              {...getFieldProps("observation", {
                initialValue: "",
                rules: [{ required: true }],
              })}
            />
          </Boxed>
      </ModalComponent>
    </>
  );
};
